import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { EOICards } from './components';
import { BackButtonStyled } from '../AddYourDocuments/AddYourDocumentsStyled';
import { DividerStyled } from '../ProfileEdit/Avatar/AvatarStyled';
import { BackButton } from '../Shared/BackButton';
import { useConfigurationQuery } from 'theSource/queries';

export const EOI = () => {
  const { t } = useTranslation('pages.eoi');
  const { configuration } = useConfigurationQuery();
  const lumosApiHost = configuration?.apiHost;

  return (
    <div data-testid="eoi">
      <BackButtonStyled>
        <BackButton label={t('common:back')} />
      </BackButtonStyled>

      <Typography
        variant="h4"
        gutterBottom
        data-testid="eoi-title"
        sx={{ mb: '1.4rem' }}
      >
        {t('title')}
      </Typography>
      <DividerStyled />
      <Typography>{t('description')}</Typography>
      <EOICards lumosApiHost={lumosApiHost}></EOICards>
    </div>
  );
};
